import {inject, injectable} from 'inversify';
import {BookingKitApiFactoryInterface} from "@/models/Factories/BookingKitApiFactoryInterface";
import {BOOKINGKIT_API_FACTORY, SUPPLIER_STATE_SERVICE} from "@/bootstrap/ServiceProviders";
import {UseSupplierInterface} from "@/state/supplier";
import {
    TicketHolder,
    TicketHolderPhoto,
    TicketHolderRequest
} from "@/services/TicketHolderService/types";
import {fromApiToTicketHolder} from "@/services/TicketHolderService/Reducers";
import TicketHolderServiceError from "./Errors/TicketHolderServiceError";
import type {UpdateVendorTicketHolderRequest} from "@bookingkit/api-v4/models";

@injectable()
export class TicketHolderService {
    private connection: ReturnType<BookingKitApiFactoryInterface['getConnection']>;

    private supplierId: string;

    constructor(
        @inject(BOOKINGKIT_API_FACTORY) factory: BookingKitApiFactoryInterface,
        @inject(SUPPLIER_STATE_SERVICE) useSupplierState: () => UseSupplierInterface,
    ) {
        const {supplier} = useSupplierState();
        this.supplierId = supplier.value!.id;
        this.connection = factory.getConnection();
        this.getTicketHolder = this.getTicketHolder.bind(this);
    }

    async getTicketHolder(getTicketHolderRequest: TicketHolderRequest): Promise<TicketHolder> {
        const { supplierId } = this;
        const {ticketHolderId} = getTicketHolderRequest;
        const { data } = await this.connection.getVendorTicketHolder({
            vendorId: supplierId,
            ticketHolderId: ticketHolderId,

        })
        if (!data) {
            throw TicketHolderServiceError.fromMissingProperty('data');
        }
        return fromApiToTicketHolder(data);
    }

    async postTicketHolderPhoto(postTicketHolderPhoto: TicketHolderPhoto) : Promise<void> {
        console.log(postTicketHolderPhoto, 'postTicketHolderPhoto');
        return Promise.reject(() => new Error('Post Photo not implemented, coming soon...'));

    }

    async patchTicketHolder(
        ticketHolderId: string,
        ticketHolderPatchRequest: UpdateVendorTicketHolderRequest
    ): Promise<TicketHolder> {
        const { supplierId } = this;
        const {data} = await this.connection.updateVendorTicketHolder({
            vendorId: supplierId,
            ticketHolderId,
            updateVendorTicketHolderRequest : ticketHolderPatchRequest
        });
        if (!data) {
            throw TicketHolderServiceError.fromMissingProperty('data');
        }
        return fromApiToTicketHolder(data);
    }

    async createTicketHolder(
        ticketHolderPatchRequest: any
    ): Promise<TicketHolder> {
        console.log('ticketHolderPatchRequest', ticketHolderPatchRequest);
        return Promise.reject(() => new Error('Creating new holder details  is not implemented yet.'));
    }

    async getTicketHolderPhoto(args: { ticketHolderId: string }): Promise<string | undefined> {
        const request = {
            vendorId: this.supplierId,
            ticketHolderId: args.ticketHolderId,
        };
        const response = await this.connection.getVendorTicketHolderPhoto(request);
        return response?.data?.url;
    }

}


export default { TicketHolderService };
